import { useConfig } from "config";
import React, { ComponentType } from "react";

import withErrorHandler from "features/common/components/ErrorHandler";

type Options<E> = {
  NoConfigComp: ComponentType<{}>;
  UncaughtErrorComp: ComponentType<E>;
};

export default function makeAppErrorHandler<P, E>(
  Component: ComponentType<P>,
  { NoConfigComp, UncaughtErrorComp }: Options<E>
) {
  function WithOfflineErrorScreen(props: P) {
    const { configError } = useConfig();
    if (configError) return <NoConfigComp />;
    else return <Component {...props} />;
  }

  return withErrorHandler(WithOfflineErrorScreen, UncaughtErrorComp, {
    errorBoundaryName: "App"
  });
}
